// Class Tailwind dùng chung giữa nhiều trang

// Thanh tab lọc (Hoạt động / Điểm đến / Tin tức), margin-top do từng trang tự thêm
export const TAB_PAGE_CLASS =
  'flex flex-wrap gap-3 max-md:flex-nowrap max-md:overflow-x-auto';

export const tabItemClass = (active: boolean) =>
  `flex h-10 cursor-pointer items-center gap-2 rounded-md border border-[rgba(0,0,0,0.1)] px-4 transition-all hover:bg-primary hover:text-white max-md:flex-none ${
    active ? 'bg-primary text-white' : 'bg-white'
  }`;

// Thẻ giá / đặt ngay (Chi tiết hoạt động, Chi tiết lưu trú)
export const CARD_NOTE_CLASS = {
  root: 'h-max rounded-[10px] border border-[rgba(0,0,0,0.1)] bg-[#1d7570] p-6 text-white shadow-[0px_4px_54px_rgba(0,0,0,0.08)]',
  price: 'text-[26px] font-semibold max-2xl:text-[24px]',
  note: 'mt-2',
  article: 'mt-5',
  viewDetail: 'btn mt-5 h-[52px] bg-[#ffffff29] text-center text-white',
};
